var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.56,14.88A5.71,5.71,0,0,0,32,11.37l0-9.32A2,2,0,0,0,31.26.51L5.93,25.83l5.48,5.57a2,2,0,0,0,2.89,0Z",
    fill: "#ff0059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.92,0h-10a5.65,5.65,0,0,0-3.49,1.46L.59,17.49a2.1,2.1,0,0,0,0,2.92l5.34,5.42L31.26.51A2.06,2.06,0,0,0,29.92,0Z",
    fill: "#ff5b5b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.88,
    cy: 8.12,
    r: 3,
    fill: "#2d4a60"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.88,
    cy: 8.12,
    r: 2,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.56ecc91ca9204862161675d12967f1e8.svg";
export { ForwardRef as ReactComponent };